export const DISCOUNT_UPDATE_REQUEST = "DISCOUNT_UPDATE_REQUEST";
export const DISCOUNT_UPDATE_SUCCESS = "DISCOUNT_UPDATE_SUCCESS";
export const DISCOUNT_UPDATE_FAIL = "DISCOUNT_UPDATE_FAIL";
export const DISCOUNT_UPDATE_RESET = "DISCOUNT_UPDATE_RESET";

export const DISCOUNT_GET_REQUEST = "DISCOUNT_GET_REQUEST";
export const DISCOUNT_GET_SUCCESS = "DISCOUNT_GET_SUCCESS";
export const DISCOUNT_GET_FAIL = "DISCOUNT_GET_FAIL";
export const DISCOUNT_GET_RESET = "DISCOUNT_GET_RESET";
